import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Voornaam "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-label" }, "*")
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Achternaam "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-label" }, "*")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Adres "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-label" }, "*")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Postcode "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-label" }, "*")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Plaats "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-label" }, "*")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("E-mailadres "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-label" }, "*")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Telefoonnummer "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-label" }, "*")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", null, "Wachtwoord wijzigen?", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("b", null, "Let op!", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Een wachtwoord moet minimaal 8 tekens lang zijn en het volgende bevatten:"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" - Letter"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" - Hoofdletter"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" - Cijfer"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" - Speciaal teken. ")
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Nieuw wachtwoord "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-label" }, "*")
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Nieuw wachtwoord bevestigen "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-label" }, "*")
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", null, "Contactgegevens behorende bij", -1)
const _hoisted_16 = { key: 0 }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Naam contactpersoon "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-label" }, "*")
], -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Adres "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-label" }, "*")
], -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Postcode "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-label" }, "*")
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Woonplaats "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-label" }, "*")
], -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("E-mailadres "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-label" }, "*")
], -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Telefoonnummer "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-label" }, "*")
], -1)

import { computed, onMounted, ref } from 'vue'
import Banner from '@/components/Banner.vue'
import { authStore } from '@/stores/auth'
import { Tenant } from '@/types/Tenant'
import { notification } from 'ant-design-vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Account',
  setup(__props) {

const auth = authStore()
const loading = ref({ user: false, tenant: false })
const newPassword = ref(false)

const user = ref({
  id: auth.user.id,
  reference: auth.user.reference,
  firstname: auth.user.firstname,
  lastname: auth.user.lastname,
  address: auth.user.address,
  zipcode: auth.user.zipcode,
  city: auth.user.city,
  email: auth.user.email,
  phone: auth.user.phone,
  password: null,
  password_confirmation: null
})

const tenantDetails = ref<Tenant[]>([])

const allRequiredUserFieldsCompleted = computed(() => {
  return (
    user.value.firstname !== '' &&
    user.value.lastname !== '' &&
    user.value.address !== '' &&
    user.value.zipcode !== '' &&
    user.value.city !== '' &&
    user.value.email !== '' &&
    user.value.phone !== ''
  )
})

const allRequiredTenantFieldsCompleted = computed(() => {
  const allTenantFieldsCompleted:boolean[] = []
  tenantDetails.value.forEach((tenant:Tenant, index:number) => {
    allTenantFieldsCompleted[index] = (
      tenantDetails.value[index].name !== '' &&
      tenantDetails.value[index].address !== '' &&
      tenantDetails.value[index].zipcode !== '' &&
      tenantDetails.value[index].city !== '' &&
      tenantDetails.value[index].email !== '' &&
      tenantDetails.value[index].phone !== ''
    )
  })
  return allTenantFieldsCompleted
})

onMounted(() => {
  setTenantDetails()
})

function setTenantDetails () : void {
  auth.user.tenants.forEach((tenant:Tenant) => {
    tenantDetails.value.push({
      id: tenant.id,
      reference: tenant.reference,
      name: tenant.name,
      address: tenant.address,
      zipcode: tenant.zipcode,
      city: tenant.city,
      email: tenant.email,
      phone: tenant.phone
    })
  })
}

function updateUser () : void {
  loading.value.user = true
  auth.updateUser(user.value).then(() => {
    notification.success({
      message: 'Persoonlijke gegevens bijgewerkt.',
      description: 'Uw persoonlijke gegevens zijn succesvol bijgewerkt.',
      duration: 5
    })
    newPassword.value = false
    user.value.password = null
    user.value.password_confirmation = null
  }).catch(() => {
    notification.error({
      message: 'Persoonlijke gegevens NIET bijgewerkt.',
      description: 'Uw persoonlijke gegevens zijn NIET bijgewerkt. Probeer het later nogmaals.',
      duration: 0
    })
  }).finally(() => {
    loading.value.user = false
  })
}

function updateTenant (tenantIndex:number) : void {
  loading.value.tenant = true
  auth.updateTenant(tenantDetails.value[tenantIndex]).then(() => {
    notification.success({
      message: 'Contactgegevens bijgewerkt.',
      description: 'Uw contactgegevens zijn succesvol bijgewerkt.',
      duration: 5
    })
  }).catch(() => {
    notification.error({
      message: 'Contactgegevens NIET bijgewerkt.',
      description: 'Uw contactgegevens zijn NIET bijgewerkt. Probeer het later nogmaals.',
      duration: 0
    })
  }).finally(() => {
    loading.value.tenant = false
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_row, { gutter: [16,16] }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, { span: 24 }, {
        default: _withCtx(() => [
          _createVNode(_component_a_card, {
            title: "Persoonlijke gegevens",
            bordered: false,
            loading: loading.value.user
          }, {
            extra: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "primary",
                disabled: !_unref(allRequiredUserFieldsCompleted),
                onClick: updateUser
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Opslaan")
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_a_row, { gutter: [32,32] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    span: 24,
                    md: 12
                  }, {
                    default: _withCtx(() => [
                      _hoisted_1,
                      _createVNode(_component_a_input, {
                        type: "text",
                        value: user.value.firstname,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((user.value.firstname) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    span: 24,
                    md: 12
                  }, {
                    default: _withCtx(() => [
                      _hoisted_2,
                      _createVNode(_component_a_input, {
                        type: "text",
                        value: user.value.lastname,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((user.value.lastname) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { gutter: [32,32] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    span: 24,
                    md: 12
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3,
                      _createVNode(_component_a_input, {
                        type: "text",
                        value: user.value.address,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((user.value.address) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    span: 24,
                    md: 4
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4,
                      _createVNode(_component_a_input, {
                        type: "text",
                        value: user.value.zipcode,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((user.value.zipcode) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    span: 24,
                    md: 8
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5,
                      _createVNode(_component_a_input, {
                        type: "text",
                        value: user.value.city,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((user.value.city) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { gutter: [32,32] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    span: 24,
                    md: 12
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6,
                      _createVNode(_component_a_input, {
                        type: "email",
                        value: user.value.email,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((user.value.email) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    span: 24,
                    md: 12
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7,
                      _createVNode(_component_a_input, {
                        type: "text",
                        value: user.value.phone,
                        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((user.value.phone) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_divider),
              _createVNode(_component_a_row, { gutter: [32,32] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    span: 24,
                    md: 12
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8,
                      _hoisted_9,
                      _createVNode(_component_a_switch, {
                        checked: newPassword.value,
                        onChange: _cache[7] || (_cache[7] = ($event: any) => (newPassword.value = !newPassword.value))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (newPassword.value)
                ? (_openBlock(), _createBlock(_component_a_row, {
                    key: 0,
                    gutter: [32,32]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _hoisted_10,
                          _hoisted_11,
                          _hoisted_12
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, {
                        span: 24,
                        md: 12
                      }, {
                        default: _withCtx(() => [
                          _hoisted_13,
                          _createVNode(_component_a_input_password, {
                            type: "text",
                            value: user.value.password,
                            "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((user.value.password) = $event))
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, {
                        span: 24,
                        md: 12
                      }, {
                        default: _withCtx(() => [
                          _hoisted_14,
                          _createVNode(_component_a_input_password, {
                            type: "text",
                            value: user.value.password_confirmation,
                            "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((user.value.password_confirmation) = $event))
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["loading"]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(auth).user.tenants, (tenant, tenantIndex) => {
            return (_openBlock(), _createBlock(_component_a_card, {
              title: "Contactgegevens",
              bordered: false,
              loading: loading.value.tenant,
              style: {"margin-top":"16px"},
              key: tenant.id
            }, {
              extra: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  disabled: !_unref(allRequiredTenantFieldsCompleted)[tenantIndex],
                  onClick: ($event: any) => (updateTenant(tenantIndex))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Opslaan")
                  ]),
                  _: 2
                }, 1032, ["disabled", "onClick"])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_a_row, { gutter: [32,32] }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_15,
                        _createElementVNode("p", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tenant.buildings, (building, index) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: building.id
                            }, [
                              _createTextVNode(_toDisplayString(building.address) + ", " + _toDisplayString(building.zipcode) + " " + _toDisplayString(building.city), 1),
                              (tenant.buildings.length !== index + 1)
                                ? (_openBlock(), _createElementBlock("br", _hoisted_16))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024),
                (tenantDetails.value.length)
                  ? (_openBlock(), _createBlock(_component_a_row, {
                      key: 0,
                      gutter: [32,32]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, {
                          span: 24,
                          md: 12
                        }, {
                          default: _withCtx(() => [
                            _hoisted_17,
                            _createVNode(_component_a_input, {
                              type: "text",
                              value: tenantDetails.value[tenantIndex].name,
                              "onUpdate:value": ($event: any) => ((tenantDetails.value[tenantIndex].name) = $event)
                            }, null, 8, ["value", "onUpdate:value"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true),
                (tenantDetails.value.length)
                  ? (_openBlock(), _createBlock(_component_a_row, {
                      key: 1,
                      gutter: [32,32]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, {
                          span: 24,
                          md: 12
                        }, {
                          default: _withCtx(() => [
                            _hoisted_18,
                            _createVNode(_component_a_input, {
                              type: "text",
                              value: tenantDetails.value[tenantIndex].address,
                              "onUpdate:value": ($event: any) => ((tenantDetails.value[tenantIndex].address) = $event)
                            }, null, 8, ["value", "onUpdate:value"])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_a_col, {
                          span: 24,
                          md: 4
                        }, {
                          default: _withCtx(() => [
                            _hoisted_19,
                            _createVNode(_component_a_input, {
                              type: "text",
                              value: tenantDetails.value[tenantIndex].zipcode,
                              "onUpdate:value": ($event: any) => ((tenantDetails.value[tenantIndex].zipcode) = $event)
                            }, null, 8, ["value", "onUpdate:value"])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_a_col, {
                          span: 24,
                          md: 8
                        }, {
                          default: _withCtx(() => [
                            _hoisted_20,
                            _createVNode(_component_a_input, {
                              type: "text",
                              value: tenantDetails.value[tenantIndex].city,
                              "onUpdate:value": ($event: any) => ((tenantDetails.value[tenantIndex].city) = $event)
                            }, null, 8, ["value", "onUpdate:value"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true),
                (tenantDetails.value.length)
                  ? (_openBlock(), _createBlock(_component_a_row, {
                      key: 2,
                      gutter: [32,32]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, {
                          span: 24,
                          md: 12
                        }, {
                          default: _withCtx(() => [
                            _hoisted_21,
                            _createVNode(_component_a_input, {
                              type: "email",
                              value: tenantDetails.value[tenantIndex].email,
                              "onUpdate:value": ($event: any) => ((tenantDetails.value[tenantIndex].email) = $event)
                            }, null, 8, ["value", "onUpdate:value"])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_a_col, {
                          span: 24,
                          md: 12
                        }, {
                          default: _withCtx(() => [
                            _hoisted_22,
                            _createVNode(_component_a_input, {
                              type: "text",
                              value: tenantDetails.value[tenantIndex].phone,
                              "onUpdate:value": ($event: any) => ((tenantDetails.value[tenantIndex].phone) = $event)
                            }, null, 8, ["value", "onUpdate:value"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["loading"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})